import ContentLayout from '@/layouts/content-layout'
import ProductsView from '@/sections/products/view/products-view'

export default function ProductsPage() {
  return (
    <ContentLayout title="สินค้า">
      <ProductsView />
    </ContentLayout>
  )
}
